import React, { useState, useRef, useEffect, useCallback } from "react";
import RolePill from "@src/components/atoms/role-pill/role-pill";

interface UseVisiblePillsProps {
  items: string[];
}

export function useVisiblePills({ items }: UseVisiblePillsProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLDivElement>(null);
  const [visibleCount, setVisibleCount] = useState(0);

  const measure = useCallback(() => {
    const container = containerRef.current;
    const measureEl = measureRef.current;
    if (!container || !measureEl) return;

    const containerWidth = container.offsetWidth;
    const widths = Array.from(measureEl.children).map(
      (c) => (c as HTMLElement).offsetWidth,
    );

    let total = 0;
    let count = 0;
    for (const w of widths) {
      if (total + w > containerWidth - 20) break;
      total += w;
      count++;
    }

    setVisibleCount(count);
  }, []);

  useEffect(() => {
    measure();
    const observer = new ResizeObserver(measure);
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [items, measure]);

  return { containerRef, measureRef, visibleCount };
}

interface PillsMeasurementProps {
  items: string[];
  measureRef: React.RefObject<HTMLDivElement>;
  cssClassName: string;
}

export const PillsMeasurement: React.FC<PillsMeasurementProps> = ({
  items,
  measureRef,
  cssClassName,
}) => (
  <div
    ref={measureRef}
    style={{
      position: "absolute",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      whiteSpace: "nowrap",
    }}
  >
    {items.map((role) => (
      <RolePill key={role} role={role} />
    ))}
    <div className={`${cssClassName}__pill`}>...</div>
  </div>
);
